/**
 * Survey flow brand — drives background, routes, and question set.
 * UniqueCode / Customer may store finer labels (`LBS Mix Red`, `LBS Purple`);
 * those still normalize to `LBS` for the questionnaire.
 */
export type CodeBrand = 'Dice' | 'LBS';

export const CODE_BRANDS: readonly CodeBrand[] = ['Dice', 'LBS'] as const;

/** True for legacy `LBS` and variants like `LBS Mix Red` / `LBS Purple`. */
export function isLbsCodeBrandLabel(raw: string | null | undefined): boolean {
  const v = (raw ?? '').trim().toLowerCase();
  return v === 'lbs' || v.startsWith('lbs ');
}

/** Normalize DB / API value; LBS variants → LBS; unknown or empty → Dice. */
export function normalizeCodeBrand(raw: string | null | undefined): CodeBrand {
  if (isLbsCodeBrandLabel(raw)) return 'LBS';
  return 'Dice';
}

export function isCodeBrand(value: string | null | undefined): value is CodeBrand {
  return value === 'Dice' || value === 'LBS';
}

/** Full-bleed survey background by brand (Tailwind needs these literal URLs). */
export function surveyBackgroundImageUrl(brand: CodeBrand | null | undefined): string {
  return brand === 'LBS' ? '/images/LBS_bg.jpg' : '/images/Dice_bg.jpg';
}

/**
 * First questionnaire route after OTP verify.
 * Both LBS and Dice start at `/smokerprofile`; brand BG + question sets diverge from there.
 */
export function surveyPathAfterOtp(_brand?: CodeBrand | null): string {
  return '/smokerprofile';
}

/** After smoker profile (incl. previous brand) both brands continue at `/7_1`. */
export function surveyPathAfterSmokerProfile(_brand?: CodeBrand | null): string {
  return '/7_1';
}

/** @deprecated Prefer `surveyPathAfterSmokerProfile` — `/otherbrands` merged into smoker profile. */
export function surveyPathAfterOtherBrands(brand?: CodeBrand | null): string {
  return surveyPathAfterSmokerProfile(brand);
}

/** After `/7_1`: LBS skips `/7_2` and continues at `/7_3`; Dice goes to `/7_2`. */
export function surveyPathAfterQ7_1(brand?: CodeBrand | null): string {
  return brand === 'LBS' ? '/7_3' : '/7_2';
}
